// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import { MonolithImageSizeFragmentDoc } from '../../components/monolithImageSize.fragment.generated';
export const NonSkuLabGrownStoneImageFragmentDoc = `
    fragment nonSkuLabGrownStoneImage on NonSkuLabGrown {
  image {
    __typename
    id
    url
    medium: size(name: MEDIUM) {
      ...monolithImageSize
    }
    medium_x2: size(name: MEDIUM_X2) {
      ...monolithImageSize
    }
  }
  shapeDimension {
    __typename
    id
    image {
      __typename
      id
      url
      medium: size(name: MEDIUM) {
        ...monolithImageSize
      }
      medium_x2: size(name: MEDIUM_X2) {
        ...monolithImageSize
      }
    }
    shape {
      __typename
      systemCode
      samplePhoto {
        __typename
        id
        url
        medium: size(name: MEDIUM) {
          ...monolithImageSize
        }
        medium_x2: size(name: MEDIUM_X2) {
          ...monolithImageSize
        }
      }
    }
  }
}
    `;